module.exports = __webpack_public_path__ + "static/img/mouth_03.d3c3da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_03.png
// module id = SYkW
// module chunks = 0